import moment from 'moment';
import type { NotificationRow } from './types';

export interface NotificationGroup {
  label: string;
  rows: NotificationRow[];
}

/**
 * Buckets rows into Today / Yesterday / Previous.
 *
 * Relative timestamps ("2 hours ago") answer "how long" but not "which day", and a flat
 * list of twenty of them is hard to scan. The headings give the eye somewhere to stop.
 *
 * Only three buckets on purpose: beyond yesterday the exact day stops mattering in a
 * dropdown, and a heading per date would be more chrome than content. The full page
 * paginates instead.
 *
 * Input is assumed newest-first, which is what the API returns; groups come back in that
 * same order and empty ones are omitted.
 *
 * @param {NotificationRow[]} rows - Notifications, newest first.
 * @return {NotificationGroup[]} Non-empty buckets, in the same order.
 */
export function groupByDay(rows: NotificationRow[]): NotificationGroup[] {
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');

  const buckets: NotificationGroup[] = [
    { label: 'Today', rows: [] },
    { label: 'Yesterday', rows: [] },
    { label: 'Previous', rows: [] },
  ];

  rows.forEach((row) => {
    const at = moment(row.createdAt);

    if (at.isSameOrAfter(today)) buckets[0].rows.push(row);
    else if (at.isSameOrAfter(yesterday)) buckets[1].rows.push(row);
    else buckets[2].rows.push(row);
  });

  return buckets.filter((bucket) => bucket.rows.length > 0);
}
